import CustomText from "../atomic/CustomText";

function PhysicianCell({ cell, row }: { cell: any; row: any }): JSX.Element {
  const physician: any =
    row?.original?.physician ?? null;
  let physicianName = physician ? physician?.firstName + ' ' + physician?.lastName : 'Pending Entry'

  return (
    <div className="flex items-center min-w-[140px]">

      <CustomText text={physicianName} fontWeight="font-normal" />
    </div>
  );
}

export default PhysicianCell;
